import { addDays } from 'date-fns';
import { today, toISODate } from '@/lib/clock';
import { ALL_CATEGORIES, type ExperienceFilters, type VehicleSearch } from '@/services/domain';

/** Default vehicle search: three weeks from today, four days, 10:00 → 10:00, Marrakech. */
export function defaultVehicleSearch(): VehicleSearch {
  const start = addDays(today(), 21);
  return {
    city: 'Marrakech',
    kind: 'car',
    start: toISODate(start),
    end: toISODate(addDays(start, 4)),
    pickupTime: '10:00',
    returnTime: '10:00',
    delivery: false,
  };
}

export const DEFAULT_EXPERIENCE_FILTERS: ExperienceFilters = {
  city: 'Marrakech',
  date: null,
  category: ALL_CATEGORIES,
  duration: '',
};
